// 用于图片全部都加载完以后执行回调函数
// 第一个参数为所有图片路径的数组。
// 第二个参数为所有图片加载完成后的回调函数。
// 第三个参数为所有图片的前置路径，如果已经是完整路径，则不需要传此参数。
export function loadImageEnd(list, callback, basePath) {
    const urls = basePath ? list.map(item => basePath + item) : list;

    // 没有图片时同样要执行回调，否则调用方的 loading 状态会一直停在 true
    if (!urls || urls.length === 0) {
        if (callback) callback([]);
        return;
    }

    // 并行发起全部请求，由浏览器连接池自行调度。
    // 旧实现复用单个 Image 对象、在 load 回调里赋下一个 src，总耗时等于所有图片 RTT 之和；
    // 一个含 32 个图标的子分类实测需 35s，改为并行后降至 7s 量级。
    const resultList = new Array(urls.length);
    let remaining = urls.length;

    urls.forEach((url, index) => {
        const img = new Image();
        // 加载成功按原始顺序占位，失败的留空，最后统一剔除
        const onSettled = (success) => {
            if (success) resultList[index] = img;
            remaining--;
            if (remaining === 0 && callback) {
                callback(resultList.filter(Boolean));
            }
        };
        img.addEventListener("load", () => onSettled(true), {once: true});
        img.addEventListener("error", () => onSettled(false), {once: true});
        img.src = url;
    });
}